import { useRef } from "react";
import { NumericFormat } from "react-number-format";
import { cn } from "@/lib/utils";

// Money entry that reads like money: thousands separators while typing (10158.35 → 10,158.35),
// max 2 decimals, selects on focus so typing replaces. `onChange` receives a number.
export function MoneyInput({ value, onChange, className, testId, placeholder = "0.00", allowNegative = false, disabled = false, prefix = "" }) {
  const selectOnMouseUp = useRef(false);
  return (
    <NumericFormat
      value={value === 0 || value === null || value === undefined ? "" : value}
      onValueChange={(v) => onChange(v.floatValue ?? 0)}
      thousandSeparator=","
      decimalScale={2}
      allowNegative={allowNegative}
      prefix={prefix}
      maxLength={16}
      disabled={disabled}
      placeholder={placeholder}
      onFocus={(e) => { selectOnMouseUp.current = true; try { e.target.select(); } catch { /* ignore */ } }}
      onMouseUp={(e) => { if (selectOnMouseUp.current) { selectOnMouseUp.current = false; e.preventDefault(); } }}
      onBlur={() => { selectOnMouseUp.current = false; }}
      inputMode="decimal"
      className={cn(
        "flex h-6 w-full rounded-md border border-input bg-transparent px-2 py-1 text-xs text-right tabular-nums shadow-sm",
        "placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      data-testid={testId}
    />
  );
}
